var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass:
        "button button-no-style button-close-icon filters__clear-filters",
      attrs: { tabindex: "0" },
      on: { click: _vm.clearFilter, keypress: _vm.clearFilterFromKeyPress },
    },
    [
      _c("span", { staticClass: "icon icon-close-circle" }),
      _vm._v("\n  Clear all filters\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }